import { useQuery } from "react-query";
import { useShopify } from "~context";
import { useAuth } from "~context/auth";
import { shopifySdk } from "~lib/shopify/client";
import { ProductSlider } from "./ProductSlider";

export const Recomendations = ({ content, id, ...props }) => {
  const { isB2B, customerCompanyId } = useShopify();
  const { getAccessToken } = useAuth();
  const { data: productRecommendations } = useQuery(
    ["productRecommendations", id, isB2B],
    async () => {
      let products = null;
      if (customerCompanyId && isB2B) {
        const token = await getAccessToken();
        products = await shopifySdk.productRecommendationsWithContext({
          productId: `${id}`,
          buyer: {
            companyLocationId: customerCompanyId,
            customerAccessToken: token,
          },
        });
      } else {
        products = await shopifySdk.productRecommendations({
          productId: `${id}`,
        });
      }
      return products.productRecommendations.filter(
        //@ts-ignore
        ({ hide }) => hide.value !== "true"
      );
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  return (
    <ProductSlider
      {...props}
      title={content?.recommendations_title}
      description={content?.recommendations_description}
      products={productRecommendations as any}
      link="/products"
    />
  );
};
